<template>
    <div>
        <el-row class="cs-contentContainer">
            <el-col :span="4" class="cs-main-left-container">
                <navigator></navigator>
            </el-col>
            <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
                <div class="cs-fullHeight cs-contentContainer-right">
                    <div class="backgroud-white cs-fullHeight">
                        <el-row>
                            <el-col :span="18" class="border-right cs-left-container">
                                <el-row class="cs-homeWorkStudentList-title">
                                    <el-col>
                                        <span class="cs-title">作业详情</span>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col>
                                        <breadcrumbNavigationBar :data="homeworkNavigationBarData"></breadcrumbNavigationBar>
                                    </el-col>
                                </el-row>
                                <el-row class="grid-content">
                                    <pagination v-loading="loading" :data="listData" :option="paginationOption" @edit="onEdit" @customEvent="customEventHandler"></pagination>
                                </el-row>
                            </el-col>
                            <el-col :span="6" class="cs-right-container">
                                <el-row>
                                    <homeworkBasicInfor :canEdit="true" :data="homeworkBasicInforData" @saveInfo="onSaveInfo"></homeworkBasicInfor>
                                </el-row>
                                <el-row>
                                    <homeworkFiles :data="homeworkFilesData"> </homeworkFiles>
                                </el-row>
                                <el-divider></el-divider>
                                <el-row>
                                    <homeworkCompleteInfor :data="homeworkCompleteInforData"></homeworkCompleteInfor>
                                </el-row>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-dialog title="学生情况报告" :center="true" :close-on-click-modal="false" width="80%" v-on:close="onCloseStudentProfile" :visible.sync="displayStudentProfile" top="5vh">
            <studentProfile :data="studentProfileData"></studentProfile>
        </el-dialog>
    </div>
</template>

<style lang="scss" scoped>
.cs-contentContainer {
    .cs-homeWorkStudentList-title {
        margin-bottom: 10px;
        ;
    }
    .cs-right-container {
        padding: 20px;
    }
    .cs-left-container {
        padding: 20px;
    }
    .grid-content {
        margin-top: 15px;
        .need-complate {
            background-color: #d5edda;
            color: #185626;
            border: 1pt solid #acd4b6;
            font-size: 10px;
        }
        .practice {
            background-color: #dbeffb;
            color: #2e74b6;
            border: 1pt solid #a9c2e3;
            font-size: 10px;
        }
        .open {
            color: #185626;
        }
        .cs-schedule-buttonContainer {
            text-align: right;
        }
    }
}
</style>

<script>
import navigator from "../../components/navigator";
import pagination from "../../components/common/pagination";
import studentProfile from "../../components/homework/studentProfile";
import homeworkBasicInfor from "../../components/homework/homeworkBasicInfor";
import homeworkFiles from "../../components/homework/homeworkFiles";
import homeworkCompleteInfor from "../../components/homework/homeworkCompleteInfor";
import breadcrumbNavigationBar from "../../components/common/breadcrumbNavigationBar";
import { getStudentHomeworkList } from "../../service/homework.service";

let moment = require("moment");

export default {
    data() {
        return {
            displayStudentProfile: false,
            loading: false,
            listData: {},
            paginationOption: {},
            homeworkId: 0,
            courseType: 1,
            courseId: 0,
            campusId: null,
            courseName: "",
            homeworkName: "",
            homeworkTypes: [],
            courseActivations: [],
            homeworkList: [],
            studentProfileData: {
                studentId: 0,
                courseId: 0,
                campusId: null,
                courseName: ""
            },
            homeworkNavigationBarData: {},
            homeworkBasicInforData: {},
            homeworkFilesData: {},
            homeworkCompleteInforData: {}
        };
    },
    components: {
        navigator,
        pagination,
        studentProfile,
        homeworkBasicInfor,
        homeworkCompleteInfor,
        homeworkFiles,
        breadcrumbNavigationBar
    },
    computed: {

    },
    created() {
        this.paginationOption = {
            displayPagination: false,
            hasEditButton: true,
            editButtonText: "查看报告",
            hasAddButton: false,
            addButtonText: "",
            hasSearch: false,
            editColumnTite: "",
            showAcitveColor: true,
            hideDisableRow: true,
        };
        this.courseId = Number(this.$route.query.courseId);
        this.campusId = Number(this.$route.query.campusId);
        this.courseName = this.$route.query.courseName;
        this.homeworkName = this.$route.query.homeworkName;
        this.homeworkId = Number(this.$route.query.homeworkId);
        this.courseType = Number(this.$route.query.courseType);
        this.initData();
    },
    methods: {
        initData() {
            this.loadListData();
            this.buildNavigations();

            this.homeworkBasicInforData = {
                courseId: this.courseId,
                homeworkId: this.homeworkId,
                campusId: this.campusId,
            };

            this.homeworkCompleteInforData = {
                homeworkId: this.homeworkId,
            }
            this.homeworkFilesData = {
                homeworkId: this.homeworkId,
            }
        },
        loadListData(){
            this.loading = true;
            getStudentHomeworkList(this.homeworkId).then(result => {
                if (!!result && result.success) {
                    this.listData = result.data;
                }
                this.loading = false;
            });
        },
        buildNavigations() {
            this.homeworkNavigationBarData = {
                name: '作业管理',
                navList: [],
                currentName: this.homeworkName
            }
            let link = "/homeworkManage?courseType=" + this.courseType
            if (this.courseType == 1) {
                this.homeworkNavigationBarData.navList.push({ link: link, name: '大学补习' });
            } else if (this.courseType == 2) {
                this.homeworkNavigationBarData.navList.push({ link: link, name: '应试英语' });
            } else {
                this.homeworkNavigationBarData.navList.push({ link: link, name: '职业培训' });
            }
            this.homeworkNavigationBarData.navList.push({
                link: "/homeworkList",
                name: this.courseName,
                data: {
                    courseType: this.courseType,
                    courseId: this.courseId,
                    courseName: this.courseName,
                    campusId: this.campusId
                }
            });
        },
        dateFormat(date) {
            var m = moment(date);
            if (m.isValid()) {
                return moment(date).format('YYYY/MM/DD hh:mm A');
            } else {
                return "";
            }

        },
        onEdit(index, row) {
            this.showStudentProfile(row);
        },
        customEventHandler(data) {
            if (data.name === "statusChange") {
                this.initData();
            } else {
                this.showStudentProfile(data);
            }
        },
        onCloseStudentProfile() {
            this.displayStudentProfile = false;
        },
        showStudentProfile(data){
            let profileData = {
                    studentId: data.StudentId,
                    courseId: this.courseId,
                    campusId: this.campusId,
                    courseName: this.courseName
                };
                this.studentProfileData = profileData;
                this.displayStudentProfile = true;
        },
        onSaveInfo(){
            this.loadListData();
            this.homeworkFilesData = {
                homeworkId: this.homeworkId,
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/page/homework/homeworkStudentList.vue